const shapeData = (data) => {
  return data.thirdPartyStreamEvents.data;
};

export { shapeData };
